<template>
  <center>
    <div class="card card-body agatrs-card-style">
      <Header pageTitle="Edit ACSA/IA" class="card-container"></Header>
      <div class="col-md-12">
        <h3>Supporting Nation: {{ supportingNation }}</h3>

        <div class="col-md-3">
          <label for="activeAcsa">Active ACSA:</label>
          <v-select
            id="activeAcsa"
            v-model="selectedActiveAcsaAgreement"
            name="ActiveAcsaAgreementDropdown"
            :reduce="(item) => item.acsaAgreementId"
            label="name"
            :options="acsaAgreementsByCountry"
            placeholder="Select"
          ></v-select>
        </div>
        <EditAcsas :AcsaId="acsaId" :CountryId="$route.params.id"></EditAcsas>

        <div class="row">
          <div class="col-md-2 align-left">
            <base-button
              @click="returnToEditAcsaDashboard()"
              class="btn btn-primary"
              v-b-popover.hover.bottom="
                'Navigate back to edit ACSAs Dashboard.'
              "
            >
              <i class="tim-icons icon-double-left"></i> Return to Table
            </base-button>
          </div>
        </div>
      </div>
    </div>
  </center>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import axios from "@/axios";
import EditAcsas from "@/components/App/admin/EditAcsas.vue";
import Header from "@/components/App/Header.vue";
import swal from "sweetalert2";

export default {
  name: "admin-edit-acsa",
  components: {
    Header,
    EditAcsas,
  },
  data() {
    return {
      supportingNation: "",
      supportingNationFullInfo: [],
      acsaId: 0,
      acsaAgreementsByCountry: [],
      selectedActiveAcsaAgreement: "",
    };
  },
  watch: {
    selectedActiveAcsaAgreement() {
      this.changeActiveAcsaAgreement();
    },
  },
  computed: {
    ...mapGetters({
      acsaAgreement: "acsaAgreement/acsaAgreement",
    }),
  },
  mounted() {
    this.getSupportingNationAndAcsaId();
    this.getAcsaAgreementsByCountry();
  },
  methods: {
    ...mapActions({
      getAcsaAgreement: "acsaAgreement/getAcsaAgreement",
    }),
    changeActiveAcsaAgreement() {
      if (this.loadedAcsaAlready) {
        this.supportingNationFullInfo.activeAcsaAgreementId = this.selectedActiveAcsaAgreement;
        axios.post("api/countries", this.supportingNationFullInfo);
      }
      this.loadedAcsaAlready = true;
    },
    returnToEditAcsaDashboard() {
      this.$router.push("/Admin/Acsas");
    },
    getSupportingNationAndAcsaId() {
      this.axios
        .get(`/api/countries/id/${this.$route.params.id}`)
        .then((response) => {
          this.supportingNation = response.data.name;
          this.supportingNationFullInfo = response.data;
          this.acsaId = response.data.activeAcsaAgreementId;
        });
    },
    getAcsaAgreementsByCountry() {
      this.axios
        .get(
          `api/acsaagreements/admin/acsas/country/${this.$route.params.id}/1/999999`
        )
        .then((response) => {
          this.acsaAgreementsByCountry = response.data.results;
          this.selectedActiveAcsaAgreement = response.data.results.filter(
            (item) => item.acsaAgreementId == this.acsaId
          );
        });
    },
  },
};
</script>

<style scoped></style>
